var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InputFeedback from "../../Input/Feedback/InputFeedback";
import Radio from "../../Input/Radio/Radio";
var RadioGroup = function (_a) {
    var title = _a.title, tip = _a.tip, name = _a.name, error = _a.error, disabled = _a.disabled, options = _a.options, reactHookForm = _a.reactHookForm, onBlur = _a.onBlur, _b = _a.hideLabel, hideLabel = _b === void 0 ? false : _b;
    return (_jsxs("fieldset", { children: [_jsx("legend", __assign({ className: "contents text-sm font-medium text-gray-900" }, { children: title })), _jsx(InputFeedback, { className: "mt-0", type: "tip", message: tip }), _jsx(InputFeedback, { className: "mt-0", type: "error", message: error }), _jsx("div", __assign({ className: "mt-4 space-y-4" }, { children: options.map(function (option, i) { return (_jsx(Radio, { name: name, value: option.value, label: option.label, onChange: option.onChange, onBlur: onBlur, disabled: disabled, error: error !== undefined, reactHookForm: reactHookForm, checked: option.checked, hideLabel: hideLabel }, i)); }) }))] }));
};
export default RadioGroup;
